<div class="hbox">
  <micro-date-picker placeholder="From" [(dateEpoch)]="from" (dateEpochChange)="refreshData()"></micro-date-picker>
  <micro-date-picker placeholder="Until" [(dateEpoch)]="until" (dateEpochChange)="refreshData()"></micro-date-picker>
</div>

<micro-chart type="chart" [options]="options"></micro-chart>
